import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './types';
import { ICycle } from 'v2/resources/types/cycles';

const cyclesSlice = createSlice({
  name: 'cycles',
  initialState,
  reducers: {
    setCycles: (state, action: PayloadAction<ICycle[]>) => {
      return {
        ...state,
        cycles: action.payload,
      };
    },
  },
});

export const { setCycles } = cyclesSlice.actions;
export default cyclesSlice.reducer;
